import { useEffect, useState } from 'react';
import { API } from '../service/ProductsService';

// שמות המוצרים והחברות להשלמה האוטומטית בשדה החיפוש (SearchBox) — בחיפוש הראשי וברשימת הקניות.
// נטען פעם אחת (spGetSearchSuggestions) ונשמר בדפדפן ל-6 שעות; כמה קומפוננטות — קריאה אחת לשרת.
const SUGGESTIONS_KEY = 'search-suggestions';
const SUGGESTIONS_TTL_MS = 6 * 60 * 60 * 1000;

const readCached = () => {
  try {
    const cached = JSON.parse(localStorage.getItem(SUGGESTIONS_KEY));
    if (cached && Date.now() - cached.savedAt < SUGGESTIONS_TTL_MS) return cached;
  } catch (e) { /* localStorage חסום / לא תקין — פשוט טוענים מהשרת */ }
  return null;
};

// בפורמט של SearchBox: [{ text, lower, type: 'product' | 'brand' }]
const toItems = ({ names = [], brands = [] }) => [
  ...names.map((text) => ({ text, lower: text.toLowerCase(), type: 'product' })),
  ...brands.map((text) => ({ text, lower: text.toLowerCase(), type: 'brand' })),
];

let pending = null;   // הטעינה מהשרת, משותפת לכל מי שמבקש בזמן שהיא רצה

const loadSuggestions = () => {
  const cached = readCached();
  if (cached) return Promise.resolve(toItems(cached));
  if (!pending) {
    pending = API.getSearchSuggestions()
      .then((resp) => {
        if (resp?.[0]?.[0]?.code !== 0) return [];
        const data = {
          savedAt: Date.now(),
          names: (resp[1] || []).map((r) => r.name),
          brands: (resp[2] || []).map((r) => r.brandName),
        };
        try { localStorage.setItem(SUGGESTIONS_KEY, JSON.stringify(data)); } catch (e) { /* אין מקום / חסום */ }
        return toItems(data);
      })
      .catch(() => [])   // בלי השלמה אוטומטית החיפוש עדיין עובד
      .finally(() => { pending = null; });
  }
  return pending;
};

export const useSearchSuggestions = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let alive = true;
    loadSuggestions().then((list) => { if (alive) setItems(list); });
    return () => { alive = false; };
  }, []);
  return items;
};
